import { Card, Flex } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { AssignmentInput } from "../inputs/AssignmentInput";
import { DescriptionInput } from "../inputs/DescriptionInput";
import { DowntimeInputItem } from "../inputs/DowntimeInputItem";
import { DuedateInput } from "../inputs/DuedateInput";
import { FrequencyInputItem } from "../inputs/FrequencyInputItem";
import { IssueInput } from "../inputs/IssueInput";
import { MaterialInputItem } from "../inputs/MaterialInputItem";
import { MediaInputItem } from "../inputs/MediaInputItem";
import { MetaInput } from "../inputs/MetaInput";
import { PriorityInput } from "../inputs/PriorityInput";
import { ProjectInput } from "../inputs/ProjectInput";
import { RestrictionInputItem } from "../inputs/RestrictionInputItem";
import { SourceInput } from "../inputs/SourceInput";
import { StateInput } from "../inputs/StateInput";
import { SubmitButton } from "../inputs/SubmitButton";
import { TitleInput } from "../inputs/TitleInput";

type Props = {};

export const FormularView = observer((props: Props) => {
  return (
    <Card>
      <Flex vertical gap="small">
        <TitleInput />
        <DescriptionInput />
        <PriorityInput type="dropdown" />
        <RestrictionInputItem type="dropdown" />
        <FrequencyInputItem type="dropdown" />
        <DowntimeInputItem type="dropdown" />
        <StateInput type="dropdown" />
        <IssueInput />
        <ProjectInput type="dropdown" />
        <AssignmentInput type="dropdown" />
        <SourceInput type="dropdown" />
        <MaterialInputItem type="dropdown" />
        <MediaInputItem type="dropdown" />
        <DuedateInput type="range" />
        <MetaInput type="modal" />
        <SubmitButton />
      </Flex>
    </Card>
  );
});
